import axios from 'axios'

import queryClient from 'Utils/queryClient'

import { ASSET_TYPE } from '../constants'
import { searchPageStore } from '../index'

const STALE_TIME = 10 * 60 * 1000
const FILTER_COUNTERS = ['style']
const COUNTER_OWN_PARAMS = {
  style: ['style_bucket'],
  subscription_tier: ['subscribed', 'subscription_tier_band'],
}
const PAGING_PARAMS = ['page', 'per_page']
const IGNORED_PARAMS = [
  ...PAGING_PARAMS,
  ...FILTER_COUNTERS
    .map(counter => COUNTER_OWN_PARAMS[counter])
    .reduce((shared, own) => shared.filter(param => own.includes(param))),
]

let latestRequest = null

export const fetchFilterCounts = (state, { url, params }) => {
  const previousAssetType = latestRequest?.assetType

  if (state.assetType === ASSET_TYPE.ALL) {
    latestRequest = null
    searchPageStore.setState({ filterCounts: {} })
    return Promise.resolve()
  }

  const countParams = { ...params, filter_counts: FILTER_COUNTERS }
  IGNORED_PARAMS.forEach((param) => { delete countParams[param] })
  const queryKey = ['searchPageFilterCounts', url, countParams]
  const request = { key: JSON.stringify(queryKey), assetType: state.assetType }
  latestRequest = request

  if (previousAssetType !== state.assetType) {
    searchPageStore.setState({ filterCounts: {} })
  }

  return queryClient
    .fetchQuery({
      queryKey,
      queryFn: ({ signal }) => axios.get(url, { params: countParams, signal }),
      staleTime: STALE_TIME,
      retry: false,
    })
    .then(({ data }) => {
      if (latestRequest !== request) return
      searchPageStore.setState({ filterCounts: data || {} })
    })
    .catch(() => {
      if (latestRequest !== request) return
      searchPageStore.setState({ filterCounts: {} })
    })
}
